import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Typography } from '@mui/material';
import { colCenter } from '../../../../style/style';
import { palette } from '../../../../../theme/palette';
const theme = palette('light');
export const TableHeader = ({ icon: Icon, text, type }) => {
    return (_jsxs(Box, { sx: { ...colCenter, gap: 1, ...type }, children: [Icon && _jsx(Icon, { style: { color: theme.primary.main } }), _jsx(Typography, { variant: 'subtitle2', color: 'white', children: text })] }));
};
